// auth.js (client)
// Etat d'authentification global (token + user) avec un mini-store d'abonnes.
// Login via popup Discord (postMessage), token stocke en localStorage et envoye
// au socket + aux appels REST.

import { serverUrl, setSocketAuth } from './socket';

const TOKEN_KEY = 'tgr_token';
let state = { token: null, user: null };
const listeners = new Set();

function emit() {
  for (const l of listeners) { try { l(state); } catch { /* noop */ } }
}

export function subscribeAuth(l) {
  listeners.add(l);
  l(state);
  return () => listeners.delete(l);
}

export function getAuth() { return state; }
export function getToken() {
  try { return state.token || localStorage.getItem(TOKEN_KEY); } catch { return state.token; }
}

function persist(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch { /* ignore */ }
}

function setSession(token, user) {
  state = { token: token || null, user: user || null };
  persist(token);
  setSocketAuth(token);
  emit();
}

export async function refreshMe() {
  const token = getToken();
  if (!token) return;
  try {
    const r = await fetch(`${serverUrl}/me`, { headers: { Authorization: `Bearer ${token}` } });
    if (r.ok) {
      const d = await r.json();
      state = { token, user: d.user };
      emit();
    } else if (r.status === 401) {
      setSession(null, null);
    }
  } catch { /* reseau: on garde l'etat courant */ }
}

export function login() {
  const w = window.open(`${serverUrl}/auth/login`, 'tgr-login', 'width=520,height=760');
  let apiOrigin;
  try { apiOrigin = new URL(serverUrl).origin; } catch { apiOrigin = null; }
  const onMsg = (e) => {
    if (apiOrigin && e.origin !== apiOrigin) return; // n'accepte que le serveur
    const d = e.data;
    if (d && d.type === 'terraguessr-auth' && d.token) {
      window.removeEventListener('message', onMsg);
      setSession(d.token, d.user || null);
      refreshMe();
    }
  };
  window.addEventListener('message', onMsg);
  return w;
}

export function logout() {
  setSession(null, null);
}

// Init au chargement : si un token existe, on rafraichit l'utilisateur (ELO a jour)
(() => {
  let token = null;
  try { token = localStorage.getItem(TOKEN_KEY); } catch { /* ignore */ }
  if (token) {
    // Le socket est deja cree avec ce token (voir socket.js) : pas de reconnexion ici.
    state = { token, user: null };
    refreshMe();
  }
})();
